export default __webpack_public_path__ + "static/media/template-store-assets.70ae8ef4.svg";